import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchSliders } from "../../../Redux/Slices/Slider";

const HomeCarousel = () => {
  const dispatch = useDispatch();
  const { slidersData } = useSelector((state) => state?.Slider);

  const fetchSlidersData = useCallback(() => {
    dispatch(FetchSliders());
  }, [dispatch]);

  useEffect(() => {
    if (!slidersData?.length) {
      fetchSlidersData();
    }
    document.title = "Home | Trusted Business Partners";
  }, [fetchSlidersData, slidersData?.length]);

  const isValidUrl = (url) => {
    return url?.startsWith("http://") || url?.startsWith("https://");
  };

  const filteredSliders = slidersData.filter(
    (item) => isValidUrl(item.image)
  );

  console.log("filterdSliders", filteredSliders)

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <p className="text-center mb-3" style={{ fontSize: "16px" }}>
          <span>2500+</span> BUSINESSES TRUST US
        </p>

        <div className="slider">
          <div className="slide-track">
            {filteredSliders?.length > 0 ? (
              <>
                {filteredSliders.map((logo, index) => (
                  <div className="slide" key={index}>
                    
                    <img
                      src={logo.image}
                      className="slider_img"
                      alt={logo.alt || logo.index || `Logo ${index}`}
                      loading="lazy"
                      width="100"
                      height="100"
                    />
                  </div>
                ))}
                {filteredSliders.map((logo, index) => (
                  <div className="slide" key={index + filteredSliders.length}>
                    <img
                      src={logo.image}
                      className="slider_img"
                      alt={logo.alt || logo.index || `Logo ${index}`}
                      loading="lazy"
                      width="100"
                      height="100"
                      />
                  </div>
                ))}
              </>
            ) : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCarousel;
